export default (node, mostUsedToolSetRef, statusBarRef) => {
  const distance = node.getBoundingClientRect();
  let mostUsedToolSetHeight;
  let mostUsedToolSetTop;
  let statusBarHeight;
  if (mostUsedToolSetRef) {
    const { current: mostUsedToolSetRefCurrent } = mostUsedToolSetRef;
    ({ offsetHeight: mostUsedToolSetHeight, offsetTop: mostUsedToolSetTop } =
      mostUsedToolSetRefCurrent);
  }

  if (statusBarRef) {
    const { current: statusBarRefCurrent } = statusBarRef;
    ({ offsetHeight: statusBarHeight } = statusBarRefCurrent);
  }

  return (
    distance.top >= 0 &&
    distance.top >= (mostUsedToolSetTop + mostUsedToolSetHeight || 88) &&
    distance.left >= 0 &&
    distance.bottom <=
      (window.innerHeight - (statusBarHeight || 24) ||
        document.documentElement.clientHeight) &&
    distance.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
};
